import me from '../response/me'
import statements from '../response/statements'
import authorisation from '../response/authorisation'
import { buildFinancialYearsFromSpecs } from './donation-fixtures'
import type { MockPersona } from './types'

const BOB_YEAR_SPECS = [
  { period: '2026-2027', count: 10 },
  { period: '2025-2026', count: 20, bigGiftPence: 450000 },
  { period: '2024-2025', count: 7, bigGiftPence: 380000 },
  { period: '2023-2024', count: 14, bigGiftPence: 325000 },
  { period: '2022-2023', count: 20, bigGiftPence: 500000 },
  { period: '2021-2022', count: 9, bigGiftPence: 350000 },
  { period: '2020-2021', count: 0 },
  { period: '2019-2020', count: 12, bigGiftPence: 420000 },
]

/** Established donor, full history, issued statements, linked accounts from Mirage seed. */
export const bobFossil: MockPersona = {
  id: 'bob-fossil',
  label: 'Bob Fossil',
  description: 'Long-time donor with full history and issued statements',
  defaultPlan: 'free',
  dashboardSeenDefault: true,
  useSeedAccounts: true,
  me: { ...me },
  donations: { financialYears: buildFinancialYearsFromSpecs(BOB_YEAR_SPECS) },
  statements,
  authorisation,
  manualDonations: [
    {
      id: 'manual-seed-amnesty',
      state: 'declared',
      charity: 'Amnesty International',
      amount: 50000,
      giftaid: 0,
      giftAidDeclared: false,
      time: '2025-12-08T10:30:00.000Z',
      source: 'manual',
      sourceCategory: 'manual',
      notes: 'Direct debit',
    },
    {
      id: 'manual-seed-oxfam',
      state: 'declared',
      charity: 'Oxfam',
      amount: 20000,
      giftaid: 0,
      giftAidDeclared: false,
      time: '2026-01-15T14:00:00.000Z',
      source: 'manual',
      sourceCategory: 'manual',
    },
  ],
  foundForYouDonations: [
    {
      id: 'ffy-201',
      charity: 'Letchworth Food Bank',
      organisationType: 'Charity',
      amount: 4000,
      potentialGiftAid: 1000,
      donatedAt: '2026-05-12T10:00:00.000Z',
      submittedAt: '2026-06-01T14:00:00.000Z',
      matchMethod: 'Contactless',
    },
    {
      id: 'ffy-202',
      charity: "St Margaret's Hospice",
      organisationType: 'Charity',
      amount: 2500,
      potentialGiftAid: 625,
      donatedAt: '2025-03-03T12:00:00.000Z',
      submittedAt: '2026-05-20T09:00:00.000Z',
      matchMethod: 'Card donation',
    },
    {
      id: 'ffy-203',
      charity: 'Hitchin Cricket Club',
      organisationType: 'CASC',
      amount: 6000,
      potentialGiftAid: 1500,
      donatedAt: '2024-11-18T16:30:00.000Z',
      submittedAt: '2026-05-18T11:00:00.000Z',
      matchMethod: 'Contactless',
    },
  ],
}
